export default "__VITE_ASSET__B5BnvY9z__"